import firebase from "firebase/app"

// Add the Firebase products that you want to use
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"
import API from "../api/api"
import axios from "axios"

const firebaseConfig = {
  apiKey: "AIzaSyBlap1vT1_b-VXvTLCCaPE8HriMx2ylSmc",
  authDomain: "one-p-b4b54.firebaseapp.com",
  projectId: "one-p-b4b54",
  storageBucket: "one-p-b4b54.appspot.com",
  messagingSenderId: "441265361712",
  appId: "1:441265361712:web:72dbba736ee200dcf6aef5",
  measurementId: "G-FFPYE2G7XY",
}

firebase.initializeApp(firebaseConfig)
class FirebaseAuthBackend {
  constructor(firebaseConfig) {
    if (firebaseConfig) {
      // Initialize Firebase

      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          const userData = JSON.stringify(user)
          localStorage.setItem("authUser", userData)
        } else {
          localStorage.removeItem("authUser")
        }
      })
    }
  }

  /**
   * Registers the user with given details
   */
  registerUser = (email, password, username) => {
    console.log(email, username, password)
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(
          response => {
            const userData = resolve(firebase.auth().currentUser)
            // console.log("userrrrr", response.user.Aa)
            axios.post(
              `${process.env.REACT_APP_API_URL}users/`,
              {
                name: username,
                authId: response.user.uid,
                isAdmin: true,
                email: email,
                phone: "",
                serviceProvider: false,
              },
              {
                withCredentials: false,
                headers: {
                  authorization: response.user.Aa,
                },
              }
            )
          },
          error => {
            reject(this._handleError(error))
          }
        )
    })
  }

  /**
   * Registers the user with given details
   */
  editProfileAPI = (email, password) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(
          user => {
            resolve(firebase.auth().currentUser)
          },
          error => {
            reject(this._handleError(error))
          }
        )
    })
  }

  /**
   * Login user with given details
   */
  loginUser = (email, password) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(
          user => {
            resolve(firebase.auth().currentUser)
          },
          error => {
            reject(this._handleError(error))
          }
        )
    })
  }

  /**
   * forget Password user with given details
   */
  forgetPassword = email => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .sendPasswordResetEmail(email, {
          url:
            window.location.protocol + "//" + window.location.host + "/login",
        })
        .then(() => {
          resolve(true)
        })
        .catch(error => {
          reject(this._handleError(error))
        })
    })
  }

  /**
   * Logout the user
   */
  logout = () => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          resolve(true)
          localStorage.removeItem("authUser")
        })
        .catch(error => {
          reject(this._handleError(error))
        })
    })
  }

  addNewUserToFirestore = user => {
    const collection = firebase.firestore().collection("users")
    const { profile } = user.additionalUserInfo
    const details = {
      firstName: profile.given_name ? profile.given_name : profile.first_name,
      lastName: profile.family_name ? profile.family_name : profile.last_name,
      fullName: profile.name,
      email: profile.email,
      picture: profile.picture,
      createdDtm: firebase.firestore.FieldValue.serverTimestamp(),
      lastLoginTime: firebase.firestore.FieldValue.serverTimestamp(),
    }
    collection.doc(firebase.auth().currentUser.uid).set(details)
    return { user, details }
  }

  setLoggeedInUser = user => {
    localStorage.setItem("authUser", JSON.stringify(user))
  }

  /**
   * Returns the authenticated user
   */
  getAuthenticatedUser = () => {
    if (!localStorage.getItem("authUser")) return null
    return JSON.parse(localStorage.getItem("authUser"))
  }

  /**
   * Handle the error
   * @param {*} error
   */
  _handleError(error) {
    // var errorCode = error.code;
    var errorMessage = error.message
    return errorMessage
  }
}

let _fireBaseBackend = null

/**
 * Initilize the backend
 * @param {*} config
 */
const initFirebaseBackend = config => {
  if (!_fireBaseBackend) {
    _fireBaseBackend = new FirebaseAuthBackend(config)
  }
  return _fireBaseBackend
}

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
  return _fireBaseBackend
}

const db = firebase.firestore()
const auth = firebase.auth()
const provider = new firebase.auth.EmailAuthProvider()
const getDocs = firebase.getDocs
const collection = firebase.collection
const storage = firebase.storage()
// const functions = firebase.functions("asia-south1")

export { initFirebaseBackend, getFirebaseBackend, db, auth, provider, getDocs ,collection, storage}
